import React, { useState } from 'react';
import location from '../images/location.png';
import Gmail from '../images/gmail.png';
import Telephone from '../images/telephone.png';
import './Contact_loc.css';

function Contact_location() {

  const locations = {
    scss: {
      name: "School of Computer & Systems Sciences",
      shortName: "SC&SS, JNU",
      address: (
        <>
          School of Computer & Systems Sciences,<br />
          Jawaharlal Nehru University,<br />
          New Delhi – 110067, India
        </>
      ),
      mapLink: "https://maps.app.goo.gl/CTEN5qoFviQGCjP68",
      mapEmbed:
        "https://www.google.com/maps?q=School+of+Computer+and+Systems+Sciences,+JNU,+New+Delhi&output=embed"
    },

    convention: {
      name: "JNU Convention Centre",
      shortName: "JNU Convention Centre",
      address: (
        <>
          JNU Convention Centre,<br />
          Jawaharlal Nehru University,<br />
          New Delhi – 110067, India
        </>
      ),
      mapLink: "https://maps.app.goo.gl/8wQWwBnA1s2j3dEDA",
      mapEmbed:
        "https://www.google.com/maps?q=JNU+Convention+Centre,+New+Delhi&output=embed"
    }
  };

  const [activeLocation, setActiveLocation] = useState("scss");

  const currentLocation = locations[activeLocation];

  return (
    <div className="contact-page">

      {/* =========================
          PAGE HEADER
      ========================== */}
      <section className="contact-header">
        <div className="container">
          <h1>
            Contact <span>Us</span>
          </h1>

          <p>
            We look forward to welcoming you to NETCRYPT 2026 at
            Jawaharlal Nehru University, New Delhi.
          </p>
        </div>
      </section>


      {/* =========================
          CONTACT + MAP SECTION
      ========================== */}
      <section className="container contact-main">

        <div className="row g-0 contact-box">

          {/* LEFT SIDE */}
          <div className="col-lg-5 contact-info">

            <div className="contact-title">
              <span className="title-line"></span>
              <h2>Get in Touch</h2>
            </div>

            <p className="contact-description">
              For any queries regarding NETCRYPT 2026, please feel free
              to contact us using the details below.
            </p>


            {/* Email */}
            <div className="contact-item">

              <div className="contact-icon">
                <img src={Gmail} alt="Email" />
              </div>

              <div>
                <h5>Email</h5>

                <a href="mailto:admin@netcrypt.org.in">
                  admin@netcrypt.org.in
                </a>
              </div>

            </div>


            {/* Telephone */}
            <div className="contact-item">

              <div className="contact-icon">
                <img src={Telephone} alt="Telephone" />
              </div>

              <div className="contact-departments">

                <h5 className="support-title">
                  Participant Support
                </h5>

                 <a href="tel:+918129651353">
                    +91-8129651353
                 </a>
                 <a href="tel:+918129651353">
                    +91-9744286649
                 </a>

                <div className="contact-department">
                  <h5>Accommodation</h5>

                  <a href="tel:+919936990986">
                    +91-9936990986
                  </a>
                   <a href="tel:+917889634201">
                    +91-7889634201
                  </a>
                </div>

                <div className="contact-department">
                  <h5>Transport</h5>

                  <a href="tel:+917006619556">
                    +91-7006619556
                  </a>

                  <a href="tel:+919776804422">
                    +91-9776804422
                  </a>
                </div>

              </div>

            </div>


            {/* Location */}
            <div className="contact-item">

              <div className="contact-icon">
                <img src={location} alt="Location" />
              </div>

              <div>
                <h5>Venue</h5>

                <p>
                  Jawaharlal Nehru University<br />
                  New Delhi – 110067, India
                </p>
              </div>

            </div>


            {/* Location selector */}
            <div className="venue-selector">

              <h5>Conference Locations</h5>

              <button
                className={
                  activeLocation === "scss"
                    ? "venue-btn active"
                    : "venue-btn"
                }
                onClick={() => setActiveLocation("scss")}
              >
                <span>01</span>
                School of Computer & Systems Sciences
              </button>

              <button
                className={
                  activeLocation === "convention"
                    ? "venue-btn active"
                    : "venue-btn"
                }
                onClick={() => setActiveLocation("convention")}
              >
                <span>02</span>
                JNU Convention Centre
              </button>

            </div>

          </div>


          {/* RIGHT SIDE - MAP */}
          <div className="col-lg-7 contact-map">

            <div className="map-header">

              <div>
                <span className="map-label">
                  CURRENT LOCATION
                </span>

                <h3>
                  {currentLocation.name}
                </h3>
              </div>

              <a
                href={currentLocation.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="direction-btn"
              >
                Get Directions ↗
              </a>

            </div>


            <div className="map-container">

              <iframe
                key={activeLocation}
                src={currentLocation.mapEmbed}
                title={currentLocation.name}
                loading="lazy"
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>

            </div>

          </div>

        </div>

      </section>


      {/* =========================
            HOW TO REACH JNU
        ========================== */}
        <section className="how-to-reach">

        <div className="container">

            {/* Section Heading */}
            <div className="reach-heading">

            <h2>
            How to <span>Reach</span>
            </h2>

            <div className="heading-line"></div>

            </div>


            {/* Route Container */}
            <div className="route-container">


            {/* =================================
                ROUTE 01 - AIRPORT
            ================================== */}
            <div className="route-block">

                <div className="route-title">

                <div className="route-title-left">

                    <span className="route-icon">✈️</span>

                    <span>
                    From Airport
                    </span>

                </div>

                <strong>
                    Delhi Airport → JNU
                </strong>

                </div>


                <div className="route-line-wrapper">

                {/* Starting Point */}
                <div className="route-point">

                    <div className="point-circle start"></div>

                    <h5>
                    Indira Gandhi
                    <br />
                    International Airport
                    </h5>

                    <span>
                    Starting Point
                    </span>

                </div>


                {/* Distance + Line */}
                <div className="route-segment">

                    <div className="segment-line"></div>

                    <span className="distance-badge">
                    ~8–10 km
                    </span>

                </div>


                {/* Intermediate */}
                <div className="route-point intermediate">

                    <div className="point-circle"></div>

                    <h5>
                    Vasant Vihar
                    </h5>

                    <span>
                    Major Landmark
                    </span>

                </div>


                {/* Distance + Line */}
                <div className="route-segment">

                    <div className="segment-line"></div>

                    <span className="distance-badge">
                    ~4–5 km
                    </span>

                </div>


                {/* Destination */}
                <div className="route-point">

                    <div className="point-circle destination"></div>

                    <h5>
                    Jawaharlal Nehru
                    <br />
                    University
                    </h5>

                    <span>
                    Destination
                    </span>

                </div>

                </div>

            </div>


            {/* =================================
                ROUTE 02 - RAILWAY
            ================================== */}
            <div className="route-block">

                <div className="route-title">

                <div className="route-title-left">

                    <span className="route-icon">🚆</span>

                    <span>
                    From Railway Station
                    </span>

                </div>

                <strong>
                    Railway Station → JNU
                </strong>

                </div>


                <div className="route-line-wrapper">

                {/* Starting Point */}
                <div className="route-point">

                    <div className="point-circle start"></div>

                    <h5>
                    New Delhi
                    <br />
                    Railway Station
                    </h5>

                    <span>
                    Starting Point
                    </span>

                </div>


                {/* Segment */}
                <div className="route-segment">

                    <div className="segment-line"></div>

                    <span className="distance-badge">
                    ~15 km
                    </span>

                </div>


                {/* Intermediate */}
                <div className="route-point intermediate">

                    <div className="point-circle"></div>

                    <h5>
                    Dhaula Kuan
                    </h5>

                    <span>
                    Major Landmark
                    </span>

                </div>


                {/* Segment */}
                <div className="route-segment">

                    <div className="segment-line"></div>

                    <span className="distance-badge">
                    ~7 km
                    </span>

                </div>


                {/* Destination */}
                <div className="route-point">

                    <div className="point-circle destination"></div>

                    <h5>
                    Jawaharlal Nehru
                    <br />
                    University
                    </h5>

                    <span>
                    Destination
                    </span>

                </div>

                </div>

            </div>


            {/* =================================
                ROUTE 03 - METRO
            ================================== */}
            <div className="route-block">

                <div className="route-title">

                <div className="route-title-left">

                    <span className="route-icon">🚇</span>

                    <span>
                    By Metro
                    </span>

                </div>

                <strong>
                    Metro → JNU
                </strong>

                </div>


                <div className="route-line-wrapper">

                {/* Starting Point */}
                <div className="route-point">

                    <div className="point-circle start"></div>

                    <h5>
                    Magenta Line
                    </h5>

                    <span>
                    Metro Route
                    </span>

                </div>


                {/* Segment */}
                <div className="route-segment">

                    <div className="segment-line"></div>

                    <span className="distance-badge">
                    Magenta Line
                    </span>

                </div>


                {/* Intermediate */}
                <div className="route-point intermediate">

                    <div className="point-circle"></div>

                    <h5>
                    Munirka
                    </h5>

                    <span>
                    Nearby Station
                    </span>

                </div>


                {/* Segment */}
                <div className="route-segment">

                    <div className="segment-line"></div>

                    <span className="distance-badge">
                    Short Ride
                    </span>

                </div>


                {/* Destination */}
                <div className="route-point">

                    <div className="point-circle destination"></div>

                    <h5>
                    JNU
                    <br />
                    Campus
                    </h5>

                    <span>
                    Destination
                    </span>

                </div>

                </div>

            </div>


            {/* Bottom Note */}
            <div className="route-footer">

                <p>
                <strong>Note:</strong> Distances are approximate and may vary
                depending on the route and traffic conditions.
                </p>

            </div>

            </div>

        </div>

        </section>

    </div>
  );
}

export default Contact_location;